import React, { useEffect, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Link, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Utils, fetchWithAuth, can } from '../../utils';
import { useActionDropdown } from "../../hooks/useActionDropdown";
import bellIcon from '../../assets/icons/bellIcon.png'
import { MdContentCopy, MdDeleteOutline } from "react-icons/md";
import { BsPencil } from "react-icons/bs";
import loader from '../../assets/loader2.gif'
const PushSetting = () => {
    const [groupName, setGroupName] = useState("") // eslint-disable-line no-unused-vars
    const [group, setGroup] = useState("")
    const [showModal, setShowModal] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [showChannelModal, setShowChannelModal] = useState(false);
    const { appId } = useParams();

    const { openActionItem, dropdownPosition, dropdownRef, closeDropdown, handleOpenDropdown } = useActionDropdown({
      optionCount: () =>
        (can("settings.messaging.group.edit") ? 1 : 0) +
        (can("settings.messaging.group.delete") ? 1 : 0),
      menuWidth: 100,
      useAnchored: false,
    });

    const [channelName, setChannelName] = useState('');
    const [channelDescription, setChannelDescription] = useState('');
    const [importance, setImportance] = useState('High');
    const [led, setLed] = useState('Default');
    const [sound, setSound] = useState('Default');
    const [vibration, setVibration] = useState('Default');
    const [badges, setBadges] = useState('Enabled');
    const [lockscreen, setLockscreen] = useState('Private');
    const [soundCustomResource, setSoundCustomResource] = useState('');
    const [vibrationCustomPattern, setVibrationCustomPattern] = useState('');
    const [ledCustomColor, setLedCustomColor] = useState('');
    const [notificationGroupId, setNotificationGroupId] = useState(0);

    const [channelUpdateId, setChannelUpdateId] = useState(0);
    const [groupUpdateId, setGroupUpdateId] = useState(0);
    const [notificationChannelId, setNotificationChannelId] = useState("");
    const [isLoading, setIsLoading] = useState(true)


    const renderGroupList = useCallback(() => {
        closeDropdown();
        fetchWithAuth(Utils.baseurl + 'getall/notification/group', {
            method: 'POST',
            body: JSON.stringify({ id: appId }),
        })
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status) {
                    setIsLoading(false)
                    setGroup(result.data)
                    setShowChannelModal(false);
                }
            })
            .catch((error) => console.error(error));
    }, [appId, closeDropdown]);

    useEffect(() => {
        renderGroupList()
    }, [renderGroupList]);

    useEffect(() => {
        if (importance === "Low" || importance === "Medium") {
            setSound("Off");
            setVibration("Default");
        }
    }, [importance]);




    const handleSubmit = () => {
        setGroupName(inputValue)
        let data = { id: appId, name: inputValue }

        if (groupUpdateId) {
            data.groupId = groupUpdateId
        }

        if (inputValue.length) {

            fetchWithAuth(Utils.baseurl + 'save/notification/group', {
                method: 'POST',
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then(async (result) => {
                    if (result.status) {
                        setGroup([result.data])
                        renderGroupList()
                        handleCloseModal();
                    }
                })
                .catch((error) => console.error(error));
        }

        handleCloseModal();
    };


    const handleSubmitChannel = () => {

        let data = {
            "notificationGroupId": notificationGroupId,
            "name": channelName,
            "description": channelDescription,
            "LED": led,
            "ledDetail": led,
            "led_color": led === 'Custom' ? ledCustomColor : null,
            "vibration": vibration,
            "vibrationDetail": vibration === 'Custom' ? vibrationCustomPattern : null,
            "sound": sound,
            "soundDetail": sound === 'Custom' ? soundCustomResource : null,
            "badge": badges === 'Enabled' ? 1 : 0,
            "Importance": importance === 'Low' ? 2 : importance === 'Medium' ? 4 : importance === 'High' ? 6 : 8,
            "lockScreen": lockscreen === 'Public' ? 1 : lockscreen === 'Private' ? 0 : -1
        }

        if (channelUpdateId) {
            data.id = channelUpdateId
        }

        if (channelName.length) {

            fetchWithAuth(Utils.baseurl + 'save/notification/channel', {
                method: 'POST',
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then(async (result) => {
                    if (result.status) {
                        renderGroupList()
                    }
                })
                .catch((error) => console.error(error));
        }

    };

    function handleDeleteChannel(id) {
        fetchWithAuth(Utils.baseurl + 'delete/notification/channel', {
            method: 'POST',
            body: JSON.stringify({ id: id }),
        })
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status) {
                    renderGroupList()
                    setShowChannelModal(false);
                }
            })
            .catch((error) => console.error(error));

    }

    function handleDeleteGroup(id) {
        fetchWithAuth(Utils.baseurl + 'delete/notification/group', {
            method: 'POST',
            body: JSON.stringify({ id: id }),
        })
            .then((response) => response.json())
            .then(async (result) => {
                if (result.status) {
                    renderGroupList()
                }
            })
            .catch((error) => console.error(error));


    }

    const handleOpenModal = (id) => {
        setGroupUpdateId(id)
        setShowModal(true);
        setInputValue('');
    };

    const handleUpdateModal = (id, name) => {
        closeDropdown();
        setGroupUpdateId(id)
        setShowModal(true);
        setInputValue(name);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setInputValue('');
    };
    const handleChannelOpenModal = (id) => {
        setNotificationChannelId("")
        setChannelName("")
        setChannelDescription("")
        setImportance('High')
        setLed('Default')
        setSound('Default')
        setVibration('Default')
        setBadges('Enabled')
        setLockscreen('Private')
        setSoundCustomResource('')
        setVibrationCustomPattern('')
        setLedCustomColor('')
        setChannelUpdateId(0)
        setNotificationGroupId(id)
        setShowChannelModal(true);


    };
    const handleChannelCloseModal = () => {
        setShowChannelModal(false);
    };



    function handleChannelUpdate(data) {
        setShowChannelModal(true)
        setChannelUpdateId(data.id)
        setNotificationChannelId(data.channel_id)
        setChannelName(data.name)
        setChannelDescription(data.description)
        setImportance(Number(data.Importance) === 2 ? 'Low' : Number(data.Importance) === 4 ? "Medium" : Number(data.Importance) === 6 ? "High" : 'Urgent')
        setLed(['Off', 'Default', 'Custom'].includes(data.ledDetail) ? data.ledDetail : (data.ledDetail === null || data.ledDetail === undefined || data.ledDetail === 0 ? 'Off' : data.ledDetail === 1 ? 'Default' : 'Custom'))
        setSound(['Off', 'Default', 'Custom'].includes(data.sound) ? data.sound : (data.sound === null || data.sound === undefined || data.sound === 0 ? 'Off' : data.sound === 1 ? 'Default' : 'Custom'))
        setVibration(['Off', 'Default', 'Custom'].includes(data.vibration) ? data.vibration : (data.vibration === null || data.vibration === undefined || data.vibration === 0 ? 'Off' : data.vibration === 1 ? 'Default' : 'Custom'))
        setSoundCustomResource(data.soundDetail || '')
        setVibrationCustomPattern(data.vibrationDetail || '')
        setLedCustomColor(data.led_color || '')
        setBadges(data.badge ? 'Enabled' : 'Disabled')
        setLockscreen(Number(data.lockScreen) === 1 ? 'Public' : Number(data.lockScreen) === -1 ? 'Secret' : 'Private')

    }

    const handleCopy = () => {
        navigator.clipboard.writeText(notificationChannelId)
            .then(() => {
                toast.success('Copied to clipboard!');
            })
            .catch((err) => {
                console.error('Failed to copy text: ', err);
            });
    };
    // style={{ backgroundColor: "#e5e8eb" }}


    return (
        <div className="dashboard_right">
            {
                !isLoading ? <div className="dashboard_inner">
                    <div className="dashboard_top">
                        <div className="dashboard_heading">
                            <h1>Messaging Channel</h1>
                        </div>

                        <div class="plateform_card inactive_plateform" style={{ marginBlock: "10px" }}>
                            {group.length && !isLoading ?
                                <div class="card_top">
                                    <div class="card_top_left">
                                        <div class="card_top_inner">
                                            <h3 color="black">Android Notification Channels</h3>

                                            <div class="active_inactive">

                                            </div>
                                        </div>
                                        <div className="sub_heading">
                                            <div className='d-flex'>

                                                <div>
                                                    <svg style={{ width: "50px", marginRight: "10px" }} viewBox="0 0 1274.37 718" fill="currentColor"> <path d="m930.77 536.42a53.07 53.07 0 1 1 53.06-53.08 53.14 53.14 0 0 1 -53.06 53.08m-586.54 0a53.07 53.07 0 1 1 53.06-53.08 53.13 53.13 0 0 1 -53.06 53.08m605.57-319.65 106.05-183.68a22.06 22.06 0 1 0 -38.21-22.09l-107.39 186c-82.12-37.48-174.35-58.35-272.76-58.35s-190.63 20.9-272.75 58.35l-107.38-186a22.06 22.06 0 1 0 -38.22 22.06l106.06 183.71c-182.11 99.05-306.67 283.41-324.89 501.23h1274.38c-18.24-217.82-142.79-402.18-324.89-501.23" fill="#3ddc84"> </path> </svg>
                                                </div>
                                                <div>
                                                    Notification channels are an Android 8.0 (API level 26) feature which gives users finer control over notifications. <br /> <button type="button" style={{ color: "rgb(72 85 177)", background: "none", border: "none", padding: 0, cursor: "pointer" }}>Channels documentation.</button>

                                                </div>
                                            </div>
                                        </div>



                                        {group.map(item => (
                                            <div key={"groupItem" + item.id} class="plateform_card inactive_plateform" style={{ width: "500px" }}>
                                                <div class="card_top">
                                                    {
                                                        <div class="card_top_left">
                                                            <div class="card_top_inner">
                                                                <h3 color="black">{item.name}</h3>

                                                                <div class="active_inactive">

                                                                </div>
                                                            </div>

                                                            {item.notificationChannels ? item.notificationChannels.map(channel => (
                                                                <div key={channel.id} onClick={() => can("settings.messaging.channel.edit") && handleChannelUpdate(channel)} className="d-flex align-items-center mb-3 p-2" style={{ cursor: can("settings.messaging.channel.edit") ? "pointer" : "default", width: "100%", borderRadius: "5px", backgroundColor: "#ececfc" }} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && can("settings.messaging.channel.edit") && handleChannelUpdate(channel)}>
                                                                    <img src={bellIcon} style={{ height: "20px", marginRight: "8px" }} alt="" />
                                                                    <span>{channel.name}</span>
                                                                </div>
                                                            )) : ""}
                                                            <div style={{ marginLeft: "25px" }}>

                                                                {can("settings.messaging.channel.add") ? (
                                                                <Link style={{ color: "rgb(72 85 177)" }} onClick={() => handleChannelOpenModal(item.id)}>
                                                                    <svg style={{ width: "17px" }} viewBox="0 0 16 16" fill="currentColor">
                                                                        <path d="M.333 8A7.667 7.667 0 108 .333 7.675 7.675 0 00.333 8zm3.334-.333A.667.667 0 014.333 7h2.5A.167.167 0 007 6.833v-2.5a.667.667 0 01.667-.666h.666A.667.667 0 019 4.333v2.5A.167.167 0 009.167 7h2.5a.667.667 0 01.666.667v.666a.667.667 0 01-.666.667h-2.5A.167.167 0 009 9.167v2.5a.667.667 0 01-.667.666h-.666A.667.667 0 017 11.667v-2.5A.167.167 0 006.833 9h-2.5a.667.667 0 01-.666-.667v-.666z" fill="currentColor">
                                                                        </path>
                                                                    </svg> &nbsp;
                                                                    Add Channel</Link>
                                                                ) : null}
                                                            </div>

                                                        </div>

                                                    }

                                                    <div className="card_top_right">
                                                        <div onClick={(e) => handleOpenDropdown(e, item.id, item)} role="button" tabIndex={0} onKeyDown={(k) => k.key === 'Enter' && handleOpenDropdown(k, item.id, item)}>
                                                            <svg style={{ height: "20px", cursor: "pointer" }} viewBox="0 0 16 16" fill="currentColor">
                                                                <path d="M8 5.25A1.625 1.625 0 108 2a1.625 1.625 0 000 3.25zM8 9.625a1.625 1.625 0 100-3.25 1.625 1.625 0 000 3.25zM9.625 12.375a1.625 1.625 0 11-3.25 0 1.625 1.625 0 013.25 0z" fill="currentColor">
                                                                </path>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        ))}

                                        <div style={{ marginLeft: "25px" }}>

                                            {can("settings.messaging.group.add") ? (
                                            <Link style={{ color: "rgb(72 85 177)" }} onClick={() => handleOpenModal(0)}>
                                                <svg style={{ width: "17px" }} viewBox="0 0 16 16" fill="currentColor">
                                                    <path d="M.333 8A7.667 7.667 0 108 .333 7.675 7.675 0 00.333 8zm3.334-.333A.667.667 0 014.333 7h2.5A.167.167 0 007 6.833v-2.5a.667.667 0 01.667-.666h.666A.667.667 0 019 4.333v2.5A.167.167 0 009.167 7h2.5a.667.667 0 01.666.667v.666a.667.667 0 01-.666.667h-2.5A.167.167 0 009 9.167v2.5a.667.667 0 01-.667.666h-.666A.667.667 0 017 11.667v-2.5A.167.167 0 006.833 9h-2.5a.667.667 0 01-.666-.667v-.666z" fill="currentColor">
                                                    </path>
                                                </svg> &nbsp;
                                                Add Group</Link>
                                            ) : null}
                                        </div>


                                    </div>
                                </div> :
                                !group.length && !isLoading ?
                                    <>

                                        <div class="card_top">
                                            <div class="card_top_inner">
                                                <h3 >No groups created. Create a group to add notification channels</h3>

                                                <div class="active_inactive">

                                                </div>
                                            </div>

                                        </div>
                                        <div class="card_footer">
                                            <div class="card_top_left">
                                                <div class="card_top_inner">
                                                    <div class="card_setting">
                                                        {can("settings.messaging.group.add") ? (
                                                        <Link style={{ color: "rgb(72 85 177)" }} onClick={() => handleOpenModal(0)}>Add Group</Link>
                                                        ) : null}

                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </>
                                    : ""


                            }
                            {showModal ?
                                <Modal show={showModal} onHide={handleCloseModal} className="ns-modal">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{groupUpdateId ? "Edit Notification Group" : "Create Notification Group"}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <span style={{ fontSize: "15px" }}> Name :</span>

                                        <input
                                            style={{ marginTop: "6px" }}
                                            type="text"
                                            value={inputValue}
                                            onChange={(e) => setInputValue(e.target.value)}
                                            placeholder=""
                                            className="form-control"
                                        />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button type="button" className="btn_theme_secondary" onClick={handleCloseModal}>
                                            Cancel
                                        </button>
                                        {((groupUpdateId && can("settings.messaging.group.edit")) || (!groupUpdateId && can("settings.messaging.group.add"))) ? (
                                        <button type="button" className="add_app_btn btn_theme_primary" onClick={handleSubmit}>
                                            <span>{groupUpdateId ? "Update" : "Add"}</span>
                                        </button>
                                        ) : null}
                                    </Modal.Footer>
                                </Modal> : showChannelModal ? <Modal show={showChannelModal} onHide={handleChannelCloseModal} className="custom-modal-size">
                                    <Modal.Header closeButton>
                                        <Modal.Title>{channelUpdateId ? "Update Notification Channel" : "Create Notification Channel"}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>

                                        {notificationChannelId.length ? <>
                                            <span>Channel ID: <code >{notificationChannelId} </code>
                                                <button type="button" style={{ border: "none" }} onClick={handleCopy}>
                                                    <MdContentCopy />
                                                </button>
                                            </span> <br /><br />
                                        </>
                                            : ""}


                                        <span style={{ fontSize: "17px" }}> User-visible channel name :</span>

                                        <input
                                            style={{ marginTop: "6px" }}
                                            type="text"
                                            value={channelName}
                                            onChange={(e) => setChannelName(e.target.value)}
                                            placeholder="Channel Name"
                                            className="form-control"
                                        />
                                        <span style={{ fontSize: "17px" }}> User-visible channel description :</span>

                                        <textarea
                                            style={{ marginTop: "6px" }}
                                            type="text"
                                            value={channelDescription}
                                            onChange={(e) => setChannelDescription(e.target.value)}
                                            className="form-control"
                                        />


                                        <fieldset style={{
                                            padding: "10px",
                                        }}>
                                            <span style={{ fontSize: "17px" }}> <b>Importance</b> : How interruptive the notification will be</span><br />
                                            {['Low', 'Medium', 'High', 'Urgent'].map(level => (
                                                <>

                                                    <label style={{

                                                        marginTop: " 2px"
                                                    }
                                                    } key={level}>
                                                        <input
                                                            type="radio"
                                                            name="importance"
                                                            value={level}
                                                            checked={importance === level}
                                                            onChange={() => setImportance(level)}
                                                        /> &nbsp;
                                                        {level}
                                                    </label>
                                                    <br />
                                                </>
                                            ))}
                                        </fieldset>

                                        {(importance === 'High' || importance === 'Urgent') && (
                                            <>
                                                <fieldset style={{ padding: "10px" }}>
                                                    <span style={{ fontSize: "17px" }}><b>Sound</b>: Play a sound when the notification is received</span><br />
                                                    {['Off', 'Default', 'Custom'].map(option => (
                                                        <label style={{ marginTop: "2px", display: "block" }} key={option}>
                                                            <input type="radio" name="sound" value={option} checked={sound === option} onChange={() => setSound(option)} /> &nbsp;{option}
                                                        </label>
                                                    ))}
                                                    {sound === 'Custom' && (
                                                        <input type="text" value={soundCustomResource} onChange={(e) => setSoundCustomResource(e.target.value)} placeholder="Resource name" className="form-control" style={{ marginTop: "6px", maxWidth: "280px" }} />
                                                    )}
                                                </fieldset>

                                                <fieldset style={{ padding: "10px" }}>
                                                    <span style={{ fontSize: "17px" }}><b>Vibration</b>: Vibrate the device when the notification is received</span><br />
                                                    {['Off', 'Default', 'Custom'].map(option => (
                                                        <label style={{ marginTop: "2px", display: "block" }} key={option}>
                                                            <input type="radio" name="vibration" value={option} checked={vibration === option} onChange={() => setVibration(option)} /> &nbsp;{option}
                                                        </label>
                                                    ))}
                                                    {vibration === 'Custom' && (
                                                        <input type="text" value={vibrationCustomPattern} onChange={(e) => setVibrationCustomPattern(e.target.value)} placeholder="(e.g. 0, 300, 500)" className="form-control" style={{ marginTop: "6px", maxWidth: "280px" }} />
                                                    )}
                                                </fieldset>
                                            </>
                                        )}

                                        <fieldset style={{ padding: "10px" }}>
                                            <span style={{ fontSize: "17px" }}><b>LED</b>: Devices that have one will blink in the chosen color</span><br />
                                            {['Off', 'Default', 'Custom'].map(option => (
                                                <label style={{ marginTop: "2px", display: "block" }} key={option}>
                                                    <input type="radio" name="led" value={option} checked={led === option} onChange={() => setLed(option)} /> &nbsp;{option}
                                                </label>
                                            ))}
                                            {led === 'Custom' && (
                                                <input type="text" value={ledCustomColor} onChange={(e) => setLedCustomColor(e.target.value)} placeholder="(e.g. FF0000FF)" className="form-control" style={{ marginTop: "6px", maxWidth: "280px" }} />
                                            )}
                                        </fieldset>






                                        <fieldset style={{
                                            padding: "10px",
                                        }}>
                                            <span style={{ fontSize: "17px" }}><b>Badges</b>: Show a badge number or notification dot on the app icon</span><br />
                                            {['Enabled', 'Disabled'].map(option => (
                                                <>

                                                    <label style={{

                                                        marginTop: " 2px"
                                                    }
                                                    } key={option}>
                                                        <input
                                                            type="radio"
                                                            name="badges"
                                                            value={option}
                                                            checked={badges === option}
                                                            onChange={() => setBadges(option)}
                                                        /> &nbsp;
                                                        {option}
                                                    </label>
                                                    <br />
                                                </>
                                            ))}
                                        </fieldset>

                                        <fieldset style={{
                                            padding: "10px",
                                        }}>
                                            <span style={{ fontSize: "17px" }}><b>Lockscreen</b>: Visibility privacy</span><br />
                                            {['Public', 'Private', 'Secret'].map(option => (
                                                <>

                                                    <label style={{

                                                        marginTop: " 2px"
                                                    }
                                                    } key={option}>
                                                        <input
                                                            type="radio"
                                                            name="lockscreen"
                                                            value={option}
                                                            checked={lockscreen === option}
                                                            onChange={() => setLockscreen(option)}
                                                        /> &nbsp;
                                                        {option}
                                                    </label>
                                                    <br />
                                                </>
                                            ))}
                                        </fieldset>

                                    </Modal.Body>
                                    <Modal.Footer>
                                        {channelUpdateId && can("settings.messaging.channel.delete") ? <button style={{ background: "none", border: "0", marginRight: "12px", color: "rgb(67, 70, 206)" }} onClick={() => handleDeleteChannel(channelUpdateId)}>
                                            delete
                                        </button> : ""}
                                        {((channelUpdateId && can("settings.messaging.channel.edit")) || (!channelUpdateId && can("settings.messaging.channel.add"))) ? (
                                        <div className="add_app" onClick={handleSubmitChannel}>
                                            <Link >
                                                <span>{channelUpdateId ? "Update" : "Create"}</span>
                                            </Link>
                                        </div>
                                        ) : null}

                                    </Modal.Footer>
                                </Modal> : ""
                            }
                        </div>



                    </div>

                </div>
                    : <div style={{ display: "flex", justifyContent: "center", height: "45px" }}>
                        <img src={loader} alt="" />
                    </div>
            }
            {openActionItem && dropdownPosition && createPortal(
                <div ref={dropdownRef} style={{ position: 'fixed', left: dropdownPosition.left, top: dropdownPosition.top, zIndex: 10000, minWidth: '220px' }}>
                    <div className="dropdown-menu-subscription">
                        {can("settings.messaging.group.edit") ? (
                        <button
                            type="button"
                            onClick={() => handleUpdateModal(openActionItem.id, openActionItem.name)}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', textAlign: 'left' }}
                        >
                            <BsPencil size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                            <span style={{ fontSize: '0.875rem' }}>Edit</span>
                        </button>
                        ) : null}
                        {can("settings.messaging.group.delete") ? (
                        <button
                            type="button"
                            className="delete-class"
                            onClick={() => { closeDropdown(); handleDeleteGroup(openActionItem.id); }}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', textAlign: 'left', color: 'red' }}
                        >
                            <MdDeleteOutline size={18} style={{ marginRight: '8px', flexShrink: 0 }} />
                            <span style={{ fontSize: '0.875rem' }}>Delete</span>
                        </button>
                        ) : null}
                    </div>
                </div>,
                document.body
            )}
        </div >
    );
};

export default PushSetting;
